import { indentstatusenum } from "@gtpl/shared-models/common-models"

export class RequestforIndentItem{
    indentMaterialPreparationId:number
    status?:indentstatusenum
    constructor(indentMaterialPreparationId:number,status?:indentstatusenum){
        this.indentMaterialPreparationId=indentMaterialPreparationId
        this.status=status;
    }
}